const EmployeeGridPluginSettings: IPluginSettings = {
    name: 'Сотрудники',
    mnemocode: 'employee_plugin',
    permission: 'Employee',
    columns: [{
        order: 0,
        propertyName: 'login',
        propertyType: 'string',
        displayName: 'Логин',
        visibility: true,
        width: 150
    }, {
        order: 1,
        propertyName: 'hash',
        propertyType: 'string',
        displayName: 'Хэш',
        visibility: true,
        width: 150
    }, {
        order: 2,
        propertyName: 'personnelNumber',
        propertyType: 'string',
        displayName: 'Табельный номер',
        visibility: true,
        width: 150
    }, {
        order: 3,
        propertyName: 'gender',
        propertyType: 'string',
        displayName: 'Пол',
        visibility: true,
        width: 150
    }, {
        order: 4,
        propertyName: 'birthDate',
        propertyType: 'datetime',
        displayName: 'Дата рождения',
        visibility: true,
        width: 150
    }, {
        order: 5,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'IdGlobal',
        visibility: false,
        width: 150
    }, {
        order: 6,
        propertyName: 'idUserGlobal',
        propertyType: 'string',
        displayName: 'idUserGlobal',
        visibility: false,
        width: 150
    }, {
        order: 7,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменения',
        visibility: true,
        width: 150
    }, {
        order: 8,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: true,
        width: 150
    }, {
        order: 9,
        propertyName: 'dateCreated',
        propertyType: 'datetime',
        displayName: 'Дата создания',
        visibility: true,
        width: 150
    }
    ],
}

export default EmployeeGridPluginSettings